// Ionic Starter App

// angular.module is a global place for creating, registering and retrieving Angular modules
// 'starter' is the name of this angular module example (also set in a <body> attribute in index.html)
// the 2nd parameter is an array of 'requires'
// 'starter.controllers' is found in controllers.js


var app = angular.module('forex-mobile', [
    'ionic',
    'ngAnimate',
    'app.controllers',
    'app.services',
    'dynform',
    'appsflyer',
    'ionic-toast',
    'ngCookies',
    '720kb.socialshare',
    'social'
]);

var controllers = angular.module('app.controllers', ['ngMessages', 'ngMask', 'angularMoment']);
var models = angular.module('app.models', ['angularMoment']);
var collections = angular.module('app.collections', []);
var services = angular.module('app.services', ['app.models', 'app.collections', 'ionic', 'angular-md5']);

app.run(['$ionicPlatform', '$ionicLoading', '$injector', 'config', 'constants', 'Storage', 'appsflyer', '$rootScope', '$state', '$q',
    '$urlRouter', 'Utils',
    function ($ionicPlatform, $ionicLoading, $injector, config, Const, Storage, appsflyer, $rootScope, $state, $q, $urlRouter, Utils) {

        $ionicPlatform.ready(function () {
            ionic.Platform.isFullScreen = true;

            log('App run phase.');
            Storage.set('platform', ionic.Platform.platform());
            $ionicLoading.show();

            $ionicPlatform.registerBackButtonAction(function (event) {
                event.preventDefault();
            }, 500);

            $injector
                .get('Init')
                .run()
                .then(function () {
                    $ionicLoading.hide();
                    deregisterFunction();
                    Utils.getURLParameterByName('action') === Const.depositActionName ? $state.go('root.app.wallet') : $state.go('root.app.assets')
                })
                .catch(function (err) {
                    log('Init run error: ', err);
                    deregisterFunction();
                    $ionicLoading.hide();
                    if (!(document.location.hash.match(/login/) || document.location.hash.match(/signup/))) {
                        return $state.go('welcome')
                    }
                    $urlRouter.sync();
                })

        });

        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            log('$stateChangeError: ', error, fromState, toState);
            event.preventDefault();
            $ionicLoading.hide();
            $state.go('welcome');
        });

        var deregisterFunction = $rootScope.$on('$stateChangeStart', function (event) {
            event.preventDefault();
        });

        $rootScope.$on('$stateChangeStart', function (ev, to, toParams, from, fromParams) {
            var constants = $injector.get('constants')
            if (constants['disabledStates'] && constants['disabledStates'].indexOf(to.name) > -1) {
                console.warn('State disabled: [', to.name, ']')
                $state.go('welcome');
                ev.preventDefault()
            }
        })
    }]);


app.config(function ($stateProvider, $urlRouterProvider, $ionicConfigProvider,
                     $socketProvider, configProvider, $animateProvider,
                     $compileProvider, appsflyerProvider, $injector) {


    function depositResolver(Storage, constants, $ionicLoading, rootResolver) {
        $ionicLoading.show({noBackdrop: true});
        return Storage
            .load('depositValue')
            .then($ionicLoading.hide)
            .catch(function (error) {
                Storage.set('depositValue', constants.defaultDeposit);
                $ionicLoading.hide();
            });
    }

    function demoDepositResolver(Storage, constants, $ionicLoading, $q, rootResolver) {
        var demoDepositValues = Storage.get('demoDepositValues');
        if (!!demoDepositValues && demoDepositValues.length) {
            return $q.resolve()
        }
        $ionicLoading.show({noBackdrop: true});

        return Storage
            .load('demoDepositValues')
            .then($ionicLoading.hide)
            .catch(function (error) {
                Storage.set('demoDepositValues', []);
                $ionicLoading.hide();
            });
    }

    function depositPaymentMethods(Storage, constants, $ionicLoading, rootResolver) {
        $ionicLoading.show({noBackdrop: true});
        return Storage
            .load('paymentMethods')
            .then($ionicLoading.hide)
            .catch(function (error) {
                $ionicLoading.hide();
            });
    }

    function tradingCentralValidator(API, Storage, config, $ionicLoading) {
        $ionicLoading.show({noBackdrop: true});
        return API.validateTCFeatures()
            .then(function(response){
                $ionicLoading.hide();
                Storage.set('validateTCFeatures', response.result);
                return true;
            }).catch(function(err){
                console.log({
                    validateTCFeaturesError: err
                })
                return true;
            })
    }

    function sendLocation(location) {
        return function (LocationService) {
            LocationService.enter(location);
            return true;
        }
    }

    $stateProvider
        .state('root', {
            url: '',
            cache: false,
            template: '<ion-nav-view/>',
            abstract: true,
            controller: ['$state', 'rootResolver', 'AccountService', function ($state, rootResolver, AccountService) {
                console.log("Root state controller: ", rootResolver);

                //TODO Maybe incorrect place for this. Also refactor.
                var state = AccountService.checkTradingAccounts();
                if (state) return $state.go(state);
            }],
            resolve: {
                rootResolver: ['$injector', '$q', function ($injector, $q) {
                    return $injector.get('Init').isInitialized ? $q.resolve() : $q.reject('not initialized!');
                }]
            }
        })
        .state('root.app', {
            url: '/app',
            cache: false,
            abstract: true,
            templateUrl: 'templates/tabs.html',
            controller: 'AppController',
            controllerAs: 'app',
            data: {
                footer: false
            }
        })
        .state('welcome', {
            url: '/welcome',
            cache: false,
            templateUrl: 'templates/welcome.html',
            controller: 'WelcomeController',
            data: {
                footer: false
            }
        })
        .state('login', {
            url: '/login',
            cache: false,
            templateUrl: 'templates/login-page.html',
            controller: 'LoginController',
            data: {
                footer: false
            }
        })
        .state('login-sms', {
            url: '/login-sms',
            cache: false,
            templateUrl: 'templates/login-page-sms.html',
            controller: 'LoginSmsController',
            data: {
                footer: false
            }
        })
        .state('login-webtrader', {
            url: '/login-webtrader',
            cache: false,
            templateUrl: 'templates/login-webtrader.html',
            controller: 'LoginWebtraderController',
            data: {
                footer: false
            }
        })
        .state('login-otp', {
            url: '/otp',
            cache: false,
            templateUrl: 'templates/login-otp.html',
            controller: 'LoginOTPController',
            params: {
                loginData: undefined
            },
            data: {
                footer: false
            }
        })
        .state('emailVerification', {
            url: '/email-verification',
            cache: false,
            templateUrl: 'templates/email-verification.html',
            controller: 'EmailVerificationController',
            data: {
                footer: false
            }
        })
        .state('signup', {
            url: '/signup',
            cache: false,
            templateUrl: 'templates/signup.html',
            controller: 'SignupController',
            resolve: {
                disableSignUp: ['$q', 'constants', function ($q, constants) {
                    return constants['disableSignup'] ? $q.reject() : $q.resolve();
                }],
            },
            data: {
                footer: false
            }
        })
        .state('signupPersonalProfile', {
            url: '/signup/personalProfile',
            cache: false,
            templateUrl: 'templates/personalProfile.html',
            controller: 'PersonalProfileController',
            resolve: {
                location: ['LocationService', sendLocation('Signup Personal Profile - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('signupQuestionnaire', {
            url: '/signup/questionnaire',
            cache: false,
            templateUrl: 'templates/questionnaire.html',
            controller: 'QuestionnaireController',
            resolve: {
                location: ['LocationService', sendLocation('Signup Questionnaire - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('forgetpassword', {
            url: '/forgetpassword',
            cache: false,
            templateUrl: 'templates/password-assistance.html',
            controller: 'PasswordAssistanceController',
            resolve: {},
            data: {
                footer: false
            }
        })
        .state('accountFrozen', {
            url: '/accountFrozen',
            cache: false,
            templateUrl: 'templates/accountFrozen.html',
            controller: 'AccountFrozenController',
            resolve: {},
            data: {
                footer: false
            }
        })
        .state('createFirstAccount', {
            url: '/createFirstAccount',
            cache: false,
            templateUrl: 'templates/createFirstAccount.html',
            controller: 'CreateFirstAccountController',
            resolve: {},
            data: {
                footer: false
            }
        })
        .state('root.app.updatepassword', {
            url: '/updatepassword',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/update-password.html',
                    controller: 'UpdatePasswordController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Update Password - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.2fa', {
            url: '/2fa',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/otp.html',
                    controller: 'OtpController'
                }
            },
            resolve: {
                twoFAEnabled: ['$q', 'constants', function ($q, constants) {
                    return constants.enable2FA ? $q.resolve() : $q.reject();
                }]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.uploadDocuments', {
            url: '/menu/uploadDocuments',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/uploadDocuments.html',
                    controller: 'UploadDocumentsController'
                }
            },
            resolve: {
                depositValue: ['$q', '$ionicLoading', 'DocumentService', function ($q, $ionicLoading, DocumentService) {
                    $ionicLoading.show({noBackdrop: true});
                    return DocumentService.initDocuments();
                }],
                location: ['LocationService', sendLocation('Upload Documents (Categories) - Webmobile')]
            },
            data: {
                footer: false
            }
        })

        .state('root.app.viewQuestionnaire', {
            url: '/menu/viewQuestionnaire',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/viewQuestionnaire.html',
                    controller: 'ViewQuestionnaireController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('View Questionnaire - Webmobile')]
            },
            data: {
                footer: false
            }
        })

        .state('root.app.verificationSumsub', {
            url: '/menu/verificationsumsub',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/verification-sumsub.html',
                    controller: 'VerificationSumsubController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Upload Documents - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.verification-v2', {
            url: '/menu/verification-v2',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/verification-v2.html',
                    controller: 'VerificationV2Controller'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Upload Documents - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.uploadDocumentsCategories', {
            url: '/menu/uploadDocuments/categories/:category',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/uploadDocumentsCategories.html',
                    controller: 'UploadDocumentsCategoriesController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Upload Documents - Webmobile')]
            },
            data: {
                footer: false
            },
            params: {
                categoryName: null,
                categoryVideoLink: null,
            },
        })
        .state('root.app.uploadDocumentsOther', {
            url: '/menu/uploadDocuments/other',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/uploadDocumentsOther.html',
                    controller: 'UploadDocumentsOtherController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Upload Other Documents - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.uploadDocumentsFiles', {
            url: '/menu/uploadDocuments/files/:baseCategory',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/uploadDocumentsFiles.html',
                    controller: 'UploadDocumentsFilesController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Upload Documents - Webmobile')]
            },
            data: {
                footer: false
            },
            params: {
                categoryName: null,
                categoryVideoLink: null,
            },
        })
        .state('root.app.inviteFriends', {
            url: '/menu/inviteFriends',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/inviteFriends.html',
                    controller: 'InviteFriendsController'
                }
            },
            resolve: {
                inviteFriends: ['$q', 'constants', 'Storage', 'API', function ($q, constants, Storage, API) {
                    if (Storage.get('friendInviteActive')) {
                        return API.getFriendInvites()
                            .then(function (response) {
                                Storage.set('inviteFriends', response.friendInvitesDetails);
                            });
                    }
                    return $q.reject();
                }]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.referralActivity', {
            url: '/menu/referralActivity',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/referralActivity.html',
                    controller: 'ReferralActivityController'
                }
            },
            resolve: {
                // inviteFriends: ['$q', 'constants', 'Storage', 'API', function ($q, constants, Storage, API) {
                //     console.log('<<<<<<<<<<');
                //     if (Storage.get('friendInviteActive')) {
                //         return API.getFriendInvites()
                //             .then((response) => {
                //                 console.log('>>>>>>>>>response', response);
                //                 Storage.set('inviteFriends', response.friendInvitesDetails);
                //             });
                //     }
                //     return $q.reject();
                // }]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.helpdesk', {
            url: '/helpdesk',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/help-desk.html',
                    controller: 'HelpDeskController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('HeldDesk - Webmobile')]
            },
            data: {
                footer: false
            }
        })

        .state('root.app.assets', {
            url: '/assets/:category',
            cache: true,
            views: {
                'tab-assets': {
                    templateUrl: 'templates/assets.html',
                    controller: 'AssetsController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Assets - Webmobile')]
            },
            data: {
                footer: true
            }
        })
        .state('root.app.assetInfo', {
            url: '/assets/:assetId/info',
            cache: true,
            views: {
                'tab-assets': {
                    templateUrl: 'templates/assetInfo.html',
                    controller: 'AssetInfoController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Asset Info - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.invest', {
            url: '/assets/:category/:assetId/:action/:volume',
            cache: false,
            views: {
                'tab-assets': {
                    templateUrl: 'templates/invest.html',
                    controller: 'InvestController'
                }
            },
            params: {
                backPage: 'root.app.assets'
            },
            resolve: {
                location: ['LocationService', sendLocation('New Trade - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.modifyTrade', {
            url: '/trades/modify/:orderId',
            cache: false,
            views: {
                'tab-opentrades': {
                    templateUrl: 'templates/modifyTrade.html',
                    controller: 'ModifyTradeController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Modify Trade - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.chart', {
            url: '/assets/:category/:assetId/chart',
            cache: false,
            views: {
                'tab-assets': {
                    templateUrl: 'templates/chart.html',
                    controller: 'ChartController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Chart - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.favorites', {
            url: '/assets/favorites',
            cache: false,
            views: {
                'tab-assets': {
                    templateUrl: 'templates/favorites.html',
                    controller: 'FavoritesController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Favorites - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.favorites-edit', {
            url: '/assets/favorites-edit',
            cache: false,
            views: {
                'tab-assets': {
                    templateUrl: 'templates/favorites-edit.html',
                    controller: 'FavoritesEditController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Edit Favorites - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.openTrades', {
            url: '/trades/open',
            cache: false,
            views: {
                'tab-opentrades': {
                    templateUrl: 'templates/openTrades.html',
                    controller: 'OpenTradeController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Open Trades - Webmobile')]
            },
            data: {
                footer: true
            }
        })
        .state('root.app.pendingTrades', {
            url: '/trades/pending',
            cache: false,
            views: {
                'tab-pending': {
                    templateUrl: 'templates/pendingTrades.html',
                    controller: 'OpenTradeController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Pending Trades - Webmobile')]
            },
            data: {
                orderFilter: 'pending',
                footer: true
            }
        })
        .state('root.app.modifyPendingTrade', {
            url: '/trades/pending/modify/:orderId',
            cache: false,
            views: {
                'tab-pending': {
                    templateUrl: 'templates/modifyPendingTrade.html',
                    controller: 'ModifyPendingTradeController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Modify Pending Trade - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.closedTrades', {
            url: '/trades/closed',
            cache: false,
            views: {
                'tab-closedtrades': {
                    templateUrl: 'templates/closedTrades.html',
                    controller: 'ClosedTradeController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Closed Trades - Webmobile')]
            },
            data: {
                footer: true
            }
        })
        .state('root.app.menu', {
            url: '/menu',
            cache: true,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/more-menu.html',
                    controller: 'MenuController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Menu - Webmobilex')],
                tradingCentralValidator: ['API', 'Storage', 'config', '$ionicLoading', tradingCentralValidator]
            },
            data: {
                footer: true
            }
        })
        .state('root.app.manageAccounts', {
            url: '/menu/manageaccounts',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/manageAccounts.html',
                    controller: 'ManageAccountsController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Manage Accounts - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.manageAccountsAdd', {
            url: '/menu/manageaccounts/add',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/addNewAccount.html',
                    controller: 'AddNewAccountController'
                }
            },
            resolve: {
                demoDepositValues: ['Storage', 'constants', '$ionicLoading', '$q', 'rootResolver', demoDepositResolver],
                location: ['LocationService', sendLocation('New Trading Account - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.manageAccountsTransfer', {
            url: '/menu/manageaccounts/transfer',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/accountsTransfer.html',
                    controller: 'AccountsTransferController',
                    resolve: {
                        transferEnabled: ['$q', 'constants', function ($q, constants) {
                            return constants.hideTransferBetweenAccounts ? $q.reject() : $q.resolve();
                        }],
                        location: ['LocationService', sendLocation('Transfer Between Accounts - Webmobile')]
                    }
                }
            },
            data: {
                footer: false
            }
        })
        .state('root.app.mangeAccountsChangePassword', {
            url: '/menu/manageaccounts/changepassword',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/accountsChangePassword.html',
                    controller: 'AccountsChangePasswordController',
                    resolve: {
                        location: ['LocationService', sendLocation('Accounts Change Password - Webmobile')]
                    }
                }
            },
            data: {
                footer: false
            }
        })
        .state('root.app.transactionHistory', {
            url: '/transactionhistory',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/transactionHistory.html',
                    controller: 'TransactionHistoryController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Transactions History - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.wallet', {
            url: '/wallet',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/wallet.html',
                    controller: 'WalletController'
                }
            },
            resolve: {
                depositPaymentMethods: ['Storage', 'constants', '$ionicLoading', 'rootResolver', depositPaymentMethods],
                location: ['LocationService', sendLocation('Wallet - Webmobile')]
            },
            data: {
                footer: true
            }
        })
        .state('root.app.withdraw', {
            url: '/withdraw/account',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdraw.html',
                    controller: 'WithdrawController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawal - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.withdrawCompliance', {
            url: '/withdraw/compliance',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdrawCompliance.html',
                    controller: 'WithdrawalComplianceController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawal Compliance - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.withdraw-cryptoWallet', {
            url: '/withdraw/cryptoWallet/:login/:amount',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdrawCryptoWallet.html',
                    controller: 'WithdrawCryptoWalletController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawal via CryptoWallet - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.withdraw-papara', {
            url: '/withdraw/papara/:login/:amount',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdrawPapara.html',
                    controller: 'WithdrawPaparaController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawal via Papara - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.withdraw-mefete', {
            url: '/withdraw/mefete/:login/:amount',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdrawMefete.html',
                    controller: 'WithdrawMefeteController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawal via Mefete - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.withdraw-wireTransfer', {
            url: '/withdraw/wireTransfer/:login/:amount',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdrawWireTransfer.html',
                    controller: 'WithdrawWireTransferController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawal via WireTransfer - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.withdraw-localWireTransfer', {
            url: '/withdraw/localWireTransfer/:login/:amount',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdrawLocalWireTransfer.html',
                    controller: 'WithdrawLocalWireTransferController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawal via LocalWireTransfer - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.withdraw-creditCard', {
            url: '/withdraw/creditCard/:login/:amount',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdrawCreditCard.html',
                    controller: 'WithdrawCreditCardController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawal via Credit Card - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.withdraw-skrill', {
            url: '/withdraw/skrill/:login/:amount',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdrawSkrill.html',
                    controller: 'WithdrawSkrillController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawal via Skrill - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.withdraw-neteller', {
            url: '/withdraw/neteller/:login/:amount',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdrawNeteller.html',
                    controller: 'WithdrawNetellerController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawal via Neteller - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.withdraw-fasapay', {
            url: '/withdraw/fasapay/:login/:amount',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdrawFasapay.html',
                    controller: 'WithdrawFasapayController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawal via FasaPay - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.withdraw-unionpay', {
            url: '/withdraw/unionpay/:login/:amount',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdrawUnionpay.html',
                    controller: 'WithdrawUnionpayController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawal via UnionPay - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.withdraw-other', {
            url: '/withdraw/other/:login/:amount',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdrawOther.html',
                    controller: 'WithdrawOtherController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawal via other method - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.withdrawHistory', {
            url: '/withdraw/history',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/withdrawHistory.html',
                    controller: 'WithdrawHistoryController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Withdrawals History - Webmobile')]
            },
            data: {
                footer: false
            }
        })

        .state('root.app.wiretransfer', {
            url: '/wallet/wiretransfer',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/wire-transfer.html',
                    controller: 'WireTransferController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Deposit via Wire Transfer - Webmobile')]
            },
            data: {
                footer: true
            }
        })
        .state('root.app.credit-card', {
            url: '/wallet/creditCard',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/creditCard.html',
                    controller: 'CreditCardController'
                }
            },
            resolve: {
                depositValue: ['Storage', 'constants', '$ionicLoading', 'rootResolver', depositResolver],
                location: ['LocationService', sendLocation('Deposit via Credit Card - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.credit-card-secured', {
            url: '/wallet/creditCardSecured',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/creditCardSecured.html',
                    controller: 'CreditCardSecuredController'
                }
            },
            resolve: {
                depositValue: ['Storage', 'constants', '$ionicLoading', 'rootResolver', depositResolver],
                location: ['LocationService', sendLocation('Deposit via Credit Card Secured - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.orangepay-btc', {
            url: '/wallet/orangepay-btc',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/orangepay-btc.html',
                    controller: 'OrangepayBtcController'
                }
            },
            resolve: {
                depositValue: ['Storage', 'constants', '$ionicLoading', 'rootResolver', depositResolver],
                location: ['LocationService', sendLocation('Deposit via OrangePay - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.praxis', {
            url: '/wallet/praxis',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/praxis.html',
                    controller: 'PraxisController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Deposit via Praxis - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.bitgo', {
            url: '/wallet/bitgo',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/bitgo.html',
                    controller: 'BitgoController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Deposit via BitGo - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.qrcode', {
            url: '/wallet/qrcode',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/qrcode.html',
                    controller: 'QrcodeController'
                }
            },
            params: {
                method: null
            },
            resolve: {
                depositValue: ['Storage', 'constants', '$ionicLoading', 'rootResolver', depositResolver],
                location: ['LocationService', sendLocation('Deposit via QrCode - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.pendingdeposit', {
            url: '/wallet/pendingdeposit',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/pendingDeposit.html',
                    controller: 'PendingDepositController'
                }
            },
            params: {
                method: null
            },
            resolve: {
                depositValue: ['Storage', 'constants', '$ionicLoading', 'rootResolver', depositResolver],
                location: ['LocationService', sendLocation('Pending Deposit Page - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.peachpayments', {
            url: '/wallet/peachpayments',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/peachpayments.html',
                    controller: 'PeachPaymentsController'
                }
            },
            params: {
                method: null
            },
            resolve: {
                depositValue: ['Storage', 'constants', '$ionicLoading', 'rootResolver', depositResolver],
                location: ['LocationService', sendLocation('Deposit via PeachPayments - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.external', {
            url: '/wallet/external',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/external.html',
                    controller: 'ExternalController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Deposit via external payment service - Webmobile')]
            },
            params: {
                method: null
            },
            data: {
                footer: false
            }
        })
        .state('root.app.banktransfer', {
            url: '/wallet/banktransfer',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/banktransfer.html',
                    controller: 'BankTransferController'
                }
            },
            params: {
                method: null
            },
            resolve: {
                depositValue: ['Storage', 'constants', '$ionicLoading', 'rootResolver', depositResolver],
                location: ['LocationService', sendLocation('Deposit via Bank Transfer - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.hostedpage', {
            url: '/wallet/hostedpage',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/hostedpage.html',
                    controller: 'HostedPageController'
                }
            },
            params: {
                method: null
            },
            resolve: {
                depositValue: ['Storage', 'constants', '$ionicLoading', 'rootResolver', depositResolver],
                location: ['LocationService', sendLocation('Deposit - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.hostedpage-popup', {
            url: '/wallet/hostedpage-popup',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/hostedpage-popup.html',
                    controller: 'HostedPagePopupController'
                }
            },
            params: {
                method: null
            },
            resolve: {
                depositValue: ['Storage', 'constants', '$ionicLoading', 'rootResolver', depositResolver],
                location: ['LocationService', sendLocation('Deposit - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.hostedpage-window', {
            url: '/wallet/hostedpage-window',
            cache: false,
            views: {
                'tab-wallet': {
                    templateUrl: 'templates/hostedpage-window.html',
                    controller: 'HostedPageWindowController'
                }
            },
            params: {
                method: null
            },
            resolve: {
                depositValue: ['Storage', 'constants', '$ionicLoading', 'rootResolver', depositResolver],
                location: ['LocationService', sendLocation('Deposit - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('root.app.personalDetails', {
            url: '/menu/personalDetails',
            cache: false,
            views: {
                'tab-menu': {
                    templateUrl: 'templates/personalDetails.html',
                    controller: 'PersonalDetailsController'
                }
            },
            resolve: {
                location: ['LocationService', sendLocation('Personal Details - Webmobile')]
            },
            data: {
                footer: false
            }
        })
        .state('kycCheck', {
            url: '/kycCheck',
            cache: false,
            templateUrl: 'templates/kycCheck.html',
            controller: 'KycCheckController',
            resolve: {},
            data: {
                footer: false
            }
        })
        .state('tnc', {
            url: '/tnc',
            cache: false,
            templateUrl: 'templates/tnc.html',
            controller: 'TncController',
            resolve: {},
            data: {
                footer: false
            }
        })
        .state('questionnaireMessage', {
            url: '/questionnaireMessage/:buttons',
            cache: false,
            templateUrl: 'templates/questionnaireMessage.html',
            controller: 'QuestionnaireMessageController',
            resolve: {},
            data: {
                footer: false
            }
        })

    // if none of the above states are matched, use this as the fallback
    //$urlRouterProvider.otherwise('/welcome');

    //$animateProvider.classNameFilter(/\banimated\b/);

    $ionicConfigProvider.views.maxCache(0);
    $ionicConfigProvider.views.forwardCache(false);
    $ionicConfigProvider.views.transition('platform');
    $ionicConfigProvider.navBar.alignTitle('left');
    $ionicConfigProvider.backButton.text('');
    $ionicConfigProvider.spinner.icon('ios');
    $ionicConfigProvider.tabs.position('bottom');


    appsflyerProvider.devKey = '';
    appsflyerProvider.appId = '';
    appsflyerProvider.options = {isDebug: true, onInstallConversionDataListener: true};

    $compileProvider.debugInfoEnabled(false);

});

